import React, { useContext } from "react";
import { primaryColor } from "assets/jss/xrs.js";

import { makeStyles } from "tss-react/mui";
import HeaderSectionLoggedID from "../SectionsPage/Sections/HeaderSectionLoggedID.js";
import ViewAccountSection from "../SectionsPage/Sections/ViewAccountSection.js";
import Context from "../../utils/context";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Box } from "@mui/material";
const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;
let drawerWidth = 150;
if (isMobile) {
  drawerWidth = 0;
}
const useStyles2 = makeStyles()((theme) => ({
  content: {
    padding: theme.spacing(3),

    paddingTop: 60,
    paddingBottom: 38,
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
}));

export default function ViewAccountPage(props) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);

  const context = useContext(Context);

  const { classes: classes2, cx } = useStyles2();

  return (
    <Box component="div" sx={{ backgroundColor: primaryColor[14] }}>
      <HeaderSectionLoggedID
        page="viewaccount"
        title="View Account"
      ></HeaderSectionLoggedID>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <main
            className={cx(classes2.content, {
              [classes2.contentShift]: context.stateDrawer,
            })}
          >
            <ViewAccountSection></ViewAccountSection>
          </main>
        </GridItem>
      </GridContainer>
    </Box>
  );
}
